import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { GlobalMessageActions, LoggerService, tryNormalizeHttpError } from '@spartacus/core';
import { from, Observable } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { WishListConnector } from '../../conectors/wish-list.connector';
import { Wishlist } from '../../wishlist.model';
import {
  CREATE_WISH_LIST,
  CreateWishList,
  CreateWishListFail,
  CreateWishListSuccess,
  LOAD_WISH_LIST,
  LoadWishList,
  LoadWishListFail,
  LoadWishListSuccess,
  REMOVE_WISH_LIST,
  RemoveWishListFail,
  RemoveWishListSuccess
} from '../actions/wish-list.action';

@Injectable()
export class WishListEffects {
  constructor(private actions$: Actions, private wishlistConnector: WishListConnector) {}
  protected logger = inject(LoggerService);
  createWishList$: Observable<CreateWishListSuccess | CreateWishListFail | GlobalMessageActions.AddMessage | LoadWishList> = createEffect(() =>
    this.actions$.pipe(
      ofType(CREATE_WISH_LIST),
      map((action: CreateWishList) => action.payload),
      mergeMap((payload: { userId: string; productCode: string }) => {
        return this.wishlistConnector.createWishlist(payload.userId, payload.productCode).pipe(
          switchMap((response: Wishlist) => {
            return [new CreateWishListSuccess(response), new LoadWishList({ userId: payload.userId })];
          }),
          catchError((error) => from([new CreateWishListFail({ error: tryNormalizeHttpError(error, this.logger) })]))
        );
      })
    )
  );

  removeWishList$: Observable<RemoveWishListSuccess | RemoveWishListFail | GlobalMessageActions.AddMessage | LoadWishList> = createEffect(() =>
    this.actions$.pipe(
      ofType(REMOVE_WISH_LIST),
      map((action: CreateWishList) => action.payload),
      mergeMap((payload: { userId: string; productCode: string }) => {
        return this.wishlistConnector.deleteWishlist(payload.userId, payload.productCode).pipe(
          switchMap((response: Wishlist) => {
            return [new RemoveWishListSuccess(response), new LoadWishList({ userId: payload.userId })];
          }),
          catchError((error) => from([new RemoveWishListFail({ error: tryNormalizeHttpError(error, this.logger) })]))
        );
      })
    )
  );

  loadWishList$: Observable<LoadWishListSuccess | GlobalMessageActions.AddMessage | LoadWishListFail> = createEffect(() =>
    this.actions$.pipe(
      ofType(LOAD_WISH_LIST),
      map((action: LoadWishList) => action.payload),
      mergeMap((payload) => {
        return this.wishlistConnector.loadWishlist(payload.userId).pipe(
          map((response: Wishlist) => {
            return new LoadWishListSuccess(response);
          }),
          catchError((error) => {
            return from([new LoadWishListFail({ error: tryNormalizeHttpError(error, this.logger) })]);
          })
        );
      })
    )
  );
}
